import { Card } from "./Card";
import { StackCard } from "./StackCard";

export class StackCardList {
    private cards: StackCard[];

    constructor(cards: StackCard[]) {
        this.cards = cards.map(stackCard => {
            return new StackCard(stackCard.card, stackCard.count);
        });
    }

    public incrementOrAddCard(card: Card, count: number) {
        const stackCard = this.find(card);
        if (stackCard) {
            stackCard.count += count;
        } else {
            this.cards.push(new StackCard(card, count));
        }
    }

    public find(card: Card) {
        return this.cards.find(item => item.card.isEqual(card));
    }

    public getAllCards() {
        return this.cards;
    }
}